{
    "Accessibility Menu": "Меню специальных возможностей",
    "Reset settings": "Сброс настроек",
    "Close": "Закрыть",
    "Content Adjustments": "Корректировка контента",
    "Adjust Font Size": "Настройка размера шрифта",
    "Highlight Title": "Выделить заголовки",
    "Highlight Links": "Выделить ссылки",
    "Readable Font": "Читаемый шрифт",
    "Color Adjustments": "Коррекция цвета",
    "Dark Contrast": "Темный контраст",
    "Light Contrast": "Светлый контраст",
    "High Contrast": "Высокий контраст",
    "High Saturation": "Высокая насыщенность",
    "Low Saturation": "Низкая насыщенность",
    "Monochrome": "Монохромный цвет",
    "Protanopia": "Протанопия",
    "Deuteranopia": "Дейтеранопия",
    "Tritanopia": "Тританопия",
    "Visual & Navigation Aids": "Визуальные и навигационные инструменты",
    "Additional Tools": "Дополнительные инструменты",
    "Reading Guide": "Руководство по чтению",
    "Stop Animations": "Остановить анимацию",
    "Big Cursor": "Большой курсор",
    "Screen Reader": "Экранный диктор",
    "Hide Images": "Скрыть изображения",
    "Image Tooltips": "Подсказки к изображениям",
    "Page Structure": "Структура страницы",
    "Super Focus": "Суперфокус",
    "Magnifier": "Лупа",
    "Increase Font Size": "Увеличить размер шрифта",
    "Decrease Font Size": "Уменьшить размер шрифта",
    "Letter Spacing": "Межбуквенное расстояние",
    "Line Height": "Высота линии",
    "Font Weight": "Вес шрифта",
    "Dyslexia Font": "Шрифт Дислексия",
    "Language": "Язык",
    "Open Accessibility Menu": "Открыть меню специальных возможностей",
    "Accessibility Profiles": "Профили доступности",
    "Seizure Safe Profile": "Безопасный профиль при эпилепсии",
    "Stops animations and reduces color saturation.": "Останавливает анимацию и снижает насыщенность цветов.",
    "Blind Profile": "Профиль для незрячих",
    "Activates the screen reader for auditory navigation.": "Активирует экранный диктор для звуковой навигации.",
    "Visually Impaired Profile": "Профиль для слабовидящих",
    "Enhances contrast and readability for low vision.": "Улучшает контраст и удобочитаемость для слабовидящих.",
    "ADHD Friendly Profile": "Профиль СДВГ",
    "Reduces distractions for better focus.": "Уменьшает отвлекающие факторы для лучшей концентрации.",
    "Cognitive & Learning Profile": "Когнитивный и учебный профиль",
    "Helpful tools for reading and comprehension.": "Полезные инструменты для чтения и понимания.",
    "Motor Impaired Profile": "Профиль двигательных нарушений",
    "Optimizes the site for keyboard-only navigation.": "Оптимизирует сайт для навигации только с клавиатуры.",
    "Headings": "Заголовки",
    "Landmarks": "Ориентиры",
    "Links": "Ссылки",
    "Focus element": "Сфокусироваться на элементе",
    "Visit link": "Открыть ссылку"
}
